import { Pipe, PipeTransform } from '@angular/core';
import { toNum } from '@shared/helpers/math.helper';

@Pipe({
    name: 'toNum',
})
export class ToNumPipe implements PipeTransform {
    transform(value: unknown): number {
        return toNum(value);
    }
}
